import {
  setSearchFlights,
  saveSearchBody,
  setSearchLink,
} from '@shared/redux/actions';
import store from '@shared/redux/store';

export const setSearchData = async res => {
  if (!res || Object.keys(res).length === 0) {
    return res;
  }

  const { current_search, info_front_flights_search_body = {} } = res || {};

  // Creamos una copia profunda del body
  const body = JSON.parse(JSON.stringify(info_front_flights_search_body));

  // Transformamos los tramos para el backend / front
  body.trip_legs =
    body?.dataTripLegs?.map(({ origin, destination, date }) => ({
      departure_date: date,
      origin: origin?.iata_code,
      destination: destination?.iata_code,
    })) || [];

  delete body.dataTripLegs;

  // 🚀 Dispatch al reducer unificado
  store.dispatch(
    setSearchFlights({
      ...body,
      trip_type: current_search,
      dataTripLegs: info_front_flights_search_body.dataTripLegs,
      search_results: res.search_results,
    })
  );

  // Dispatchs adicionales que mantenés para otros fines
  store.dispatch(saveSearchBody(body));
  store.dispatch(setSearchLink({ link: null }));

  return res;
};
